// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__SIwip","rootSuccess":"CompleteLink_rootSuccess__HhyRf","rootFailure":"CompleteLink_rootFailure__qwiol","isDisabled":"CompleteLink_isDisabled__1td41"};